// src/langs.ts — display names + the picker's ordered language set.
// Lives here (not in Llabaro.tsx) so LanguagePicker and the LiveClient can import it
// without a circular import.
export const LANGS: Record<string, string> = {
  en: "English",
  es: "Spanish",
  fr: "French",
  de: "German",
  it: "Italian",
  pt: "Portuguese",
  nl: "Dutch",
  pl: "Polish",
  ru: "Russian",
  tr: "Turkish",
  ar: "Arabic",
  hi: "Hindi",
  zh: "Chinese",
  ja: "Japanese",
  ko: "Korean",
};

// Order shown in the language picker wheels.
export const PICKER_ORDER: string[] = [
  "en",
  "es",
  "fr",
  "de",
  "it",
  "pt",
  "nl",
  "pl",
  "ru",
  "tr",
  "ar",
  "hi",
  "zh",
  "ja",
  "ko",
];
